// extracted by mini-css-extract-plugin
export default {"pageWrapper":"auth_pageWrapper__oHURH","appName":"auth_appName__qkHTU"};